import React from "react";
import { Text } from "@chakra-ui/react";
import useCopySku from "@/features/pathpick/hooks/useCopySku";

interface Props {
  sku: string | null | undefined;
  // SKU가 없을 때 값 자리에 표시할 문구 (기본 "-")
  emptyText?: string;
}

/**
 * 리스트 아이템에서 쓰는 "SKU {값}" 한 줄 텍스트.
 * 상품 카드(PathPickProductCard)의 SKU와 마찬가지로 눌러서 SKU를 복사할 수 있다.
 * 카드처럼 "SKU" 접두사는 라벨로 두고 값만 hover/클릭 대상이며, 복사되는 것도 값뿐이다.
 */
export default function PathPickCopyableSkuText({
  sku,
  emptyText = "-",
}: Props) {
  const { copySku } = useCopySku();

  // 값이 없으면 복사할 게 없으므로 클릭 스타일도 주지 않는다.
  const canCopy = Boolean(sku);

  const handleCopy = (event: React.MouseEvent) => {
    // 행 클릭(선택 토글/상세 열기)까지 번지지 않게 막는다.
    event.stopPropagation();
    copySku(sku);
  };

  return (
    <Text
      textStyle={"caption-medium"}
      color={"#8F8F8C"}
      noOfLines={1}
      wordBreak={"break-all"}
    >
      {"SKU "}
      {/* 접두사는 라벨일 뿐이라 값만 떼어내 hover/클릭 대상으로 삼는다.
        색을 따로 주지 않아 평소에는 부모 색을 그대로 상속한다. */}
      <Text
        as={"span"}
        {...(canCopy && {
          // 밑줄이 없으면 클릭 가능하다는 신호가 없어 hover 색으로 대신한다.
          _hover: { color: "#1272EF" },
          cursor: "pointer",
          onClick: handleCopy,
        })}
      >
        {sku ?? emptyText}
      </Text>
    </Text>
  );
}
